module.exports = __webpack_public_path__ + "media/rare.f6fa48b7.webm";